import { useQuery } from 'react-query';
import { ContributionsApi } from '../api';
import { Contribution, UserContribution } from '../model';
import { useContributions } from './useContributions';

export function useUserContributions(): {
  active?: UserContribution;          // pierwszy z aktywnych – dla kompatybilności
  actives: UserContribution[];        // ⇐ NOWE: wszystkie aktywne
  history: UserContribution[];
  userContribution?: Contribution;
} {
  const contributionsRaw = useContributions();
  const contributions: Contribution[] = Array.isArray(contributionsRaw) ? contributionsRaw : [];

  const { data: userContribRaw } = useQuery<UserContribution[]>(
    'user-contributions',
    ContributionsApi.fetch
  );
  const userContrib: UserContribution[] = Array.isArray(userContribRaw) ? userContribRaw : [];

  // ⇐ kluczowa zmiana: lista aktywnych zamiast pojedynczego find()
  const actives = userContrib.filter((item) => Boolean(item?.active));
  const history = userContrib.filter((item) => !item?.active);

  // Dopasowanie po type/name (jeśli chcesz zostawić)
  const activeKey = (actives[0] as any)?.type ?? (actives[0] as any)?.name ?? null;
  const firstHistoryKey = (history[0] as any)?.type ?? (history[0] as any)?.name ?? null;

  const userContribution =
    contributions.find((c: any) => c?.type === activeKey) ??
    contributions.find((c: any) => c?.type === firstHistoryKey);

  return {
    active: actives[0],
    actives,
    history,
    userContribution,
  };
}